module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-1.58af78a1.png";